export default {
    root: ({ context }) => ({
        class: [
            'flex-shrink-0 relative whitespace-nowrap inline-flex items-center justify-center',
            'cursor-pointer select-none',
            'px-4 py-2',
            /* tw */ 'min-h-12',

            // Colors
            /* tw */ 'border-b-2 border-transparent',
            'font-medium',

            // Transitions & Effects
            'transition-colors duration-200',

            // States
            {
                'text-gray-700 hover:text-black': !context.disabled && !context.active,
                'border-black text-black': context.active,
            },
            'disabled:pointer-events-none disabled:opacity-60',
            'focus-visible:z-10 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-[-1px] focus-visible:outline-primary',
        ],
    }),
};
